import * as React from "react";
import { AppHeader } from "@duosoftbg/nacid-frontoffice-components";

type HeaderProps = {
  hideSubHeader?: boolean;
};

const Header = ({ hideSubHeader = false }: HeaderProps) => {
  return <AppHeader hideSubHeader={hideSubHeader} />;
};
export default Header;
